import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZUtilModule } from '@knz/util';

import { XlsxDirective } from './xlsx.directive';

const COMPONENTS = [XlsxDirective];

@NgModule({
  imports: [CommonModule, KNZUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class XlsxModule {}
